module.exports = __webpack_public_path__ + "static/media/tvshows.40aa6901.svg";